import React, { useState } from "react";
import { FormControl, Checkbox } from 'react-bootstrap';

const AddBallot = ({ partyData, ballotRestrictions }) => {
const [newBallot, ] = useState([]);


const ShowBallot = () => {
    return (
      <div className='margin-ballot'>
            <>
            <div className='bg-wrapper'>
              <div id={'bg_new'} className='bg-left'>
                  <>
                    <table width='100%'>
                      <tr>
                        <td>Add Ballot:</td>
                      </tr>
                      <tr>
                        <td>
                          <FormControl
                            type='textarea'
                            placeholder='Enter ballot'
                            key={'bn_new'}
                            name={'bn_new'}
                            aria-label='Ballot name'
                            style={{ width: '90%' }}
                            value={newBallot}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Add Candidates:</td>
                      </tr>
                      <tr>
                        <td>
                          <div className='indent-candidate'>
                            <div>
                              <table width='90%'>
                                <tr>
                                  <td>
                                    <FormControl
                                      type='textarea'
                                      placeholder='Add New'
                                      key={'new_candidate'}
                                      name={'new_candidate'}
                                      aria-label='Candidate name'
                                      style={{ width: '100%' }}
                                    />{' '}
                                  </td>
                                  <td>
                                    <FormControl
                                      componentClass='select'
                                      placeholder='select'
                                      aria-label='Candidate party'
                                      style={{
                                        width: '100%',
                                        marginLeft: '10px',
                                      }}
                                    >
                                      <option value='0'>Select party</option>
                                      {partyData.map((x) => (
                                        <option
                                          key={x.ballotCandidatePartyId}
                                          value={x.ballotCandidatePartyId}
                                        >
                                          {x.ballotCandidatePartyName}
                                        </option>
                                      ))}
                                      <option value='0'>Independent</option>
                                    </FormControl>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table width='100%'>
                            <tr>
                              <td width='18%'> Allow Write Ins:</td>
                              <td
                                style={{
                                  verticalAlign: 'middle',
                                  paddingTop: '25px',
                                }}
                                      >
                                        <Checkbox aria-label='Allow write-in candidates' />
                                      </td>
                                    </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table width='100%'>
                            <tr>
                              <td width='30%'>
                                {' '}
                                Number of Selections Allowed:
                              </td>
                              <td style={{ height: '20px' }}>
                                <FormControl
                                  type='text'
                                  placeholder='1'
                                  aria-label='Number of selections allowed'
                                  style={{ width: '10%', height: '30px' }}
                                />
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table width='100%'>
                            <tr>
                              <td width='30%'> Restrictions:</td>
                              <td style={{ height: '20px' }}>
                                <FormControl
                                  componentClass='select'
                                  placeholder='select'
                                  aria-label='Ballot restriction'
                                  style={{ width: '70%', marginTop: '30px' }}
                                >
                                  <option value=''>Select Restriction</option>
                                  <option
                                    value=''
                                  >
                                    None
                                  </option>
                                  {ballotRestrictions.map((x) => (
                                    <option
                                      key={x.ballotRestrictionDetailId}
                                      value={x.ballotRestrictionDetail}
                                    >
                                      {x.ballotRestrictionDescription}
                                    </option>
                                  ))}
                                </FormControl>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </>
              </div>
            </div>
            </>
      </div>
    ) ; 
}
  return (
      <ShowBallot />

  );
}
export default AddBallot;
